import ACContentCardLarge from 'academy-common-lib/components/card/ACContentCardLarge';
import { ACContentCardSmall } from 'academy-common-lib/components/card/ACContentCardSmall';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { getDisplayCategories } from 'academy-common-lib/utils/categories';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getCatalogResourceUrl } from '../../routing';
import { jsx as _jsx } from "react/jsx-runtime";
const CONTAINER_TYPE_TO_CONTENT_TYPE = {
  COURSE: 'COURSE',
  LESSON: 'LESSON',
  SHORT_FORM_CONTENT: 'VIDEO'
};
const getContentType = resource => {
  if ('certification' in resource && resource.certification === true) {
    return 'CERTIFICATION';
  }
  return CONTAINER_TYPE_TO_CONTENT_TYPE[resource.type];
};
export const AcademyContentCard = ({
  model,
  compact,
  clipRange,
  contentHref: contentHrefOverride
}) => {
  const {
    isMobile
  } = useMediaQuery();
  const sharedProps = {
    name: model.name,
    imageSrc: isMobile ? model.previewThumbnailSquareUrl : model.previewThumbnailRectangleUrl,
    contentHref: contentHrefOverride !== null && contentHrefOverride !== void 0 ? contentHrefOverride : getCatalogResourceUrl(model),
    contentType: getContentType(model),
    length: model.duration,
    lengthType: 'time'
  };
  if (compact !== null && compact !== void 0 ? compact : isMobile) {
    return /*#__PURE__*/_jsx(ACContentCardSmall, Object.assign({}, sharedProps));
  }
  return /*#__PURE__*/_jsx("div", {
    style: {
      maxWidth: 300
    },
    children: /*#__PURE__*/_jsx(ACContentCardLarge, Object.assign({}, sharedProps, {
      clipRange: clipRange,
      videoLength: clipRange ? model.duration : undefined,
      tags: getDisplayCategories(model.subCategories).map(categoryKey => /*#__PURE__*/_jsx(FormattedMessage, {
        message: `academyCommon.categories.${categoryKey}`
      }, categoryKey))
    }))
  });
};